import {connect} from 'react-redux';

import {
  createSelector,
  makeMapStateToProps,
  wrapInDeepEqualSelector,
} from '../../../../srcCommon/helpers/reselectHelpers';
import {serializePreferencesForApplication} from '../../../helpers/models/applicationSerializationHelpers';
import {LegacyEntryPoint} from '../../../models/api/legacyEntryPointModel';
import {AppState} from '../../../store/appState';
import {getLegacyApplications} from '../../../store/data/applications/legacyApplicationsSelectors';
import {getUser} from '../../../store/data/teammates/teammatesSelectors';
import {LegacyApplicationContextHost} from './legacyApplicationContextHost';

/*
 * Props.
 */

interface LegacyApplicationContextHostContainerProps {
  entryPoint: LegacyEntryPoint;
}

/*
 * Selectors.
 */

function getApplicationId(_state: AppState, props: LegacyApplicationContextHostContainerProps) {
  return props.entryPoint.applicationId;
}

function makeGetApplication() {
  return createSelector([getLegacyApplications, getApplicationId], (applications, applicationId) => {
    const application = applications[applicationId];
    if (!application) {
      throw new Error('Application could not be found for entry point.');
    }

    return application;
  });
}

function makeGetApplicationPreferences(getApplication: ReturnType<typeof makeGetApplication>) {
  return createSelector([getUser, getApplication], (user, application) =>
    serializePreferencesForApplication(user, application),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<LegacyApplicationContextHostContainerProps>()(() => {
  const getApplication = makeGetApplication();
  const getPreferences = makeGetApplicationPreferences(getApplication);

  return {
    user: getUser,
    application: getApplication,
    preferences: wrapInDeepEqualSelector(getPreferences),
  };
});

export const LegacyApplicationContextHostContainer = connect(mapStateToProps)(LegacyApplicationContextHost);
